import { useEffect, useState, startTransition } from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { islandUrl, tr } from "@/lib/translations";

/** Startseite „Beliebte Orte“: Orte mit den meisten Online-Objekten als Linkliste auf die Ortsseiten (interne Verlinkung / Long-Tail-SEO). */
export const HomePlaces = ({ limit = 12 }) => {
  const { t, lang } = useLang();
  const [places, setPlaces] = useState([]);
  useEffect(() => { api.get("/places/popular", { params: { limit } }).then((r) => startTransition(() => setPlaces(r.data))).catch(() => setPlaces([])); }, [limit]);
  if (!places.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-10 home-section border-t border-stone-200" data-testid="home-places">
      <div className="home-section-head">
        <div className="text-xs uppercase tracking-[0.3em] text-brand flex items-center gap-2"><MapPin className="w-4 h-4" />{t.places.subtitle}</div>
        <h2 className="font-serif text-4xl md:text-5xl text-stone-900 mt-3">{t.places.title}</h2>
      </div>
      <ul className="flex flex-wrap gap-3">
        {places.map((p) => (
          <li key={p.slug}>
            <Link to={`${islandUrl(p.island)}/${p.slug}`} title={`${t.places.link.replace("{n}", p.name)} · ${tr(p.island_name, lang)}`}
                  className="group inline-flex items-center gap-2 rounded-full border border-line bg-white px-4 py-2 text-sm text-stone-800 transition-colors hover:border-brand hover:text-brand" data-testid={`home-place-${p.slug}`}>
              <span>{t.places.link.replace("{n}", p.name)}</span>
              <span className="rounded-full bg-tint px-2 py-0.5 text-[11px] text-stone-600 group-hover:text-brand">{p.property_count}</span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};
